/** Sezione Red Flag: cruscotto, segnalazioni, scheda, nuova segnalazione, report settimanale. */
import type { Forma } from "../forma";

export const it = {
  cruscotto: {
    titolo: "Red Flag",
    sottotitolo: "Cruscotto per direzione ed ExCo. Aggiornato in tempo reale, non più il venerdì.",
    nuova: "Nuova segnalazione",
    report: "Report settimanale",
    aperti: "Aperti",
    urgenti: "{{n}} urgenti",
    critici: "Critici",
    criticiDelta: "{{d}} da venerdì",
    criticiUguali: "come venerdì",
    valore: "Valore a rischio",
    senzaValore: "{{n}} senza valore",
    persi: "Persi",
    valorePersi: "{{v}} di progetti",
    costo: "Costo della non qualità",
    costoVuoto: "campo nuovo, da compilare",
    perSeverita: "Per severità (aperti)",
    perTipo: "Per tipo di segnalazione (aperte)",
    tipoProposto: "tipo proposto",
    tipoDaScegliere: "Tipo da scegliere",
    inRitardo: "In ritardo PRO 09",
    inRitardoNota: "aggiornamento al cliente scaduto",
    azioni: "Azioni aperte",
    azioniScadute: "{{n}} scadute",
    proposti: "{{n}} proposti",
    temi: "Temi ricorrenti",
    temiNota: "I temi si calcolano dalle cause classificate (campo «chi l'ha causato»), non si scrivono a mano.",
    temiVuotoTitolo: "Nessun tema",
    temiVuoto: "Compaiono quando l'admin approva tipo e cause con «chi l'ha causato».",
    fornitori: "Fornitori con più casi",
    fornitoriRiga: "{{nc}} NC · {{claim}} claim",
    fornitoriRigaNc: "{{nc}} NC",
    fornitoriVuoto: "Nessun fornitore con NC",
    andamento: "Andamento settimanale",
    andamentoNota: "Segnalazioni aperte a fine settimana.",
    andamentoTip: "{{s}}: {{n}} aperti",
  },
  elenco: {
    titolo: "Segnalazioni",
    sottotitolo: "{{n}} segnalazioni. Prima le nuove e le aggiornate, poi per data.",
    cerca: "Cerca cliente, progetto, PO…",
    tutteSeverita: "Tutte le severità",
    tuttiStati: "Tutti gli stati",
    tutteSocieta: "Tutte le società",
    tuttiTipi: "Tutti i tipi",
    soloUrgenti: "Solo urgenti",
    soloAperte: "Solo aperte",
    soloRitardo: "In ritardo PRO 09",
    soloVip: "Solo VIP",
    tutteFonti: "Tutte le fonti",
    tuttiTipiSegnalazione: "Tutti i tipi",
    prossimo: "Prossimo agg.",
    azioni: "Azioni",
    codice: "Codice",
    data: "Data",
    cliente: "Cliente / progetto",
    societa: "Società",
    severita: "Severità",
    valore: "Valore",
    tipo: "Tipo",
    nc: "NC",
    owner: "Owner",
    stato: "Stato",
    vuoto: "Nessuna segnalazione con questi filtri",
  },
  flag: { NEW: "NEW", UPD: "AGG." },
  urgente: "URG",
  vip: "VIP",
  urgenteLungo: "URGENTE",
  processo: {
    p1: "1 · Segnalata",
    p1r: "chi la riceve",
    p2: "2 · Presa in carico",
    p2r: "subito (PRO 09)",
    p3: "3 · Azioni in corso",
    p3r: "correttive e preventive",
    p4: "4 · Chiusa",
    p4r: "verificata col cliente",
  },
  pro09: {
    titolo: "Tempi col cliente (PRO 09)",
    ricevuta: "Ricevuta il",
    presaInCarico: "Presa in carico",
    nonPresa: "non ancora",
    prendi: "Prendi in carico",
    presaOk: "Presa in carico",
    ultimo: "Ultimo aggiornamento al cliente",
    nessuno: "nessuno",
    prossimo: "Prossimo aggiornamento dovuto",
    inRitardo: "in ritardo di {{n}} giorni lavorativi",
    inTempo: "in tempo",
    regola: "Primo aggiornamento entro 2 giorni lavorativi, poi ogni 5 (VIP ogni 2), fino alla chiusura.",
    regolaVip: "Cliente VIP: aggiornamento ogni 2 giorni lavorativi.",
    registra: "Registra aggiornamento al cliente",
    registraTesto: "Cosa hai comunicato al cliente",
    registraData: "Data dell'aggiornamento",
    registrato: "Aggiornamento al cliente registrato: il conteggio riparte",
    chiusa: "Chiusa il {{data}}, verificata col cliente",
    nonAperta: "Segnalazione non aperta: nessun tempo da rispettare",
    ritardoBreve: "in ritardo",
  },
  azioni: {
    titolo: "Azioni (ISO 9001)",
    spiega: "Correttiva immediata: contiene il problema adesso. Preventiva: perché non accada più.",
    crea: "Crea azione",
    nuova: "Nuova azione",
    modifica: "Modifica azione",
    aggiorna: "Aggiorna",
    aggiornaTitolo: "Aggiorna {{codice}}",
    tipo: "Tipo",
    descrizione: "Descrizione",
    funzione: "Funzione",
    owner: "Persona",
    ownerPh: "utente del portale o nome",
    scadenza: "Scadenza",
    stato: "Stato",
    nota: "Nota dell'aggiornamento",
    notaPh: "cosa è stato fatto (facoltativo)",
    vuotaTitolo: "Nessuna azione",
    vuota: "Crea la correttiva immediata e, quando la causa è chiara, la preventiva.",
    scaduta: "scaduta",
    creataOk: "Azione {{codice}} creata",
    verificaSoloQualita: "«Verificata» la mette la qualità",
    storico: "Aggiornamenti dell'azione",
    mie: "Le mie azioni",
    mieSottotitolo: "Le azioni assegnate a te, da tutte le segnalazioni.",
    tutte: "Tutte le azioni",
    soloAperte: "Solo aperte",
    soloScadute: "Solo scadute",
    segnalazione: "Segnalazione",
    vuotoElenco: "Nessuna azione con questi filtri",
    migrata: "dal file (azione di Massimo)",
  },
  allegati: {
    titolo: "Allegati",
    carica: "Trascina qui i file o clicca per sceglierli",
    caricaNota: "Mail .msg ed .eml, PDF, foto, Office. Massimo {{mb}} MB per file, {{n}} file per volta.",
    caricando: "Caricamento…",
    caricati: "{{n}} allegati caricati",
    vuoto: "Nessun allegato",
    apri: "Apri",
    scarica: "Scarica",
    rimuovi: "Rimuovi",
    rimuoviConferma: "Rimuovere l'allegato dalla segnalazione?",
    rimuoviMail: "Con la mail se ne vanno anche i suoi allegati.",
    rimosso: "Allegato rimosso",
    da: "Da",
    a: "A",
    cc: "Cc",
    data: "Data",
    oggetto: "Oggetto",
    corpo: "Testo della mail",
    allegatiMail: "Allegati della mail",
    nonEstratti: "Non estratti: {{elenco}}",
    motivo_formato: "formato non ammesso",
    motivo_dimensione: "troppo grande",
    motivo_profondita: "mail dentro una mail dentro una mail",
    "motivo_non leggibile": "non leggibile",
    caricatoDa: "{{chi}}, {{quando}}",
    anteprimaNo: "Anteprima non disponibile per questo formato: scarica il file.",
    troppoGrande: "{{nome}}: troppo grande (massimo {{mb}} MB)",
    formato: "{{nome}}: formato non ammesso",
    dopoCreazione: "Gli allegati si caricano appena la segnalazione è creata.",
  },
  apriNc: {
    bottone: "Apri NC da questa segnalazione",
    titolo: "Apri una NC collegata",
    nota: "La segnalazione non è una NC: aprila solo se serve un'azione verso un fornitore o una funzione interna, con l'8D.",
    tipo: "Tipo di NC",
    fornitore: "Fornitore",
    funzione: "Funzione",
    apri: "Apri la NC",
    aperta: "NC aperta",
  },
  scheda: {
    sottotitolo: "{{codice}} · {{societa}} · prima segnalazione {{data}}",
    aggiungiAggiornamento: "Aggiungi aggiornamento",
    testoAggiornamento: "Cosa è cambiato",
    modificaDati: "Modifica i dati",
    cosa: "Cosa è successo",
    problema: "Problema",
    causa: "Causa (prima lettura)",
    impatto: "Impatto sul cliente",
    azioneInCorso: "Azione in corso",
    notaLingua: "Testi importati dal file settimanale, nella lingua in cui sono scritti.",
    classificazione: "Tipo e cause",
    tipoSegnalazione: "Tipo di segnalazione",
    fonte: "Fonte",
    fonteDettaglio: "Dettaglio della fonte",
    vip: "Cliente VIP",
    creataDa: "Creata da",
    verificataConCliente: "Verificata col cliente (serve per chiudere)",
    propostaInAttesa: "proposta {{codice}} · in attesa dell'admin",
    propostaDa: "proposta da {{chi}}",
    approvata: "approvata",
    nessunaClassificazione: "Tipo e cause non ancora decisi: proponili.",
    classificazioneNota: "Tipo di segnalazione, cosa vede il cliente, chi l'ha causato. Approvarli non apre NC: la NC si apre a mano, se serve.",
    causaCliente: "Cosa vede il cliente",
    causaChi: "Chi l'ha causato",
    fornitore: "Fornitore (VendorHub)",
    fornitoreCerca: "cerca nel VendorHub…",
    fornitoreFile: "nel file: {{nome}}",
    approvaApri: "Approva",
    modificaApprova: "Modifica e approva",
    rifiuta: "Rifiuta",
    proponi: "Proponi modifica",
    proponiNota: "la proposta va all'admin",
    propostaInviata: "Proposta inviata all'admin",
    approvataOk: "Tipo e cause approvati",
    ncAperteOk: "NC aperte: {{codici}}",
    rifiutataOk: "Proposta rifiutata",
    tipiObbligatori: "Scegli il tipo di segnalazione",
    ncTitolo: "NC collegate",
    ncVuotaTitolo: "Nessuna NC",
    ncVuotaCommerciale: "Caso commerciale: si chiude con l'analisi della gara.",
    ncVuotaAttesa: "La segnalazione non è una NC. La qualità ne apre una solo se serve.",
    ncCol: "NC",
    ncTipo: "Tipo",
    ncFornitore: "Fornitore / funzione",
    ncFase: "Fase 8D",
    ncOwner: "Owner",
    ncScadenza: "Scadenza",
    aggiornamenti: "Aggiornamenti",
    nessunAggiornamento: "Nessun aggiornamento",
    dati: "Dati",
    cliente: "Cliente",
    progetto: "Progetto",
    societa: "Società",
    valore: "Valore a rischio",
    costo: "Costo non qualità",
    casoSf: "Caso Salesforce",
    casoSfEsempio: "es. 00012345",
    poSap: "CO / PO SAP",
    ownerCommerciale: "Owner commerciale",
    ownerQualita: "Owner qualità",
    severita: "Severità",
    urgente: "Urgente",
    stato: "Stato",
    claimTitolo: "Claim collegato",
    claimProposto: "Collegamento proposto ({{codice}}), da confermare in Proposte.",
    claimDaVerificare: "da verificare",

    proposte: "Proposte su questa segnalazione",
  },
  nuova: {
    titolo: "Nuova segnalazione",
    sottotitolo: "Due minuti. Il resto lo completa la qualità.",
    societa: "Società",
    cliente: "Cliente",
    clientePh: "nome del cliente",
    progetto: "Progetto / prodotto",
    progettoPh: "es. shopping bag EMEA",
    problema: "Cosa è successo",
    problemaPh: "Il problema come lo vede il cliente",
    impatto: "Impatto sul cliente",
    impattoPh: "cosa succede al cliente: linea ferma, consegna a rischio, immagine…",
    fonte: "Fonte",
    fontePh: "da dove arriva la segnalazione",
    fonteDettaglio: "Dettaglio della fonte",
    fonteDettaglioPh: "chi ha segnalato, riferimento (facoltativo)",
    tipoSegnalazione: "Tipo di segnalazione",
    casoSfObbligatorio: "Con la fonte Salesforce serve il numero del caso",
    severita: "Severità",
    urgente: "Urgente",
    valore: "Valore a rischio",
    valorePh: "importo",
    valuta: "Valuta",
    casoSf: "Caso Salesforce",
    poSap: "PO / CO SAP",
    facoltativo: "facoltativo",
    data: "Data di ricezione",
    dataNota: "da qui partono i tempi della PRO 09",
    allegati: "Allegati",
    invia: "Invia segnalazione",
    inviata: "Segnalazione {{codice}} creata",
    allegatiErrore: "Segnalazione creata, ma gli allegati non sono stati caricati: riprova dalla scheda",
    obbligatorio: "Campo obbligatorio",
    criteri: "Criteri di severità",
  },
  report: {
    titolo: "Report settimanale · {{settimana}}",
    sottotitolo: "Generato dal portale. Sostituisce la mail del venerdì e l'xlsx allegato.",
    settimana: "Settimana",
    copia: "Copia testo per la mail",
    copiato: "Testo copiato negli appunti",
    bozza: "Crea bozza in Outlook",
    generato: "Generato il {{quando}}",
    aperti: "Aperti",
    nuove: "Nuove criticità",
    aggiornate: "Aggiornate",
    avanzamento: "Avanzamento",
    ncAperte: "NC aperte",
    ncSenzaOwner: "NC senza owner",
    azioniScadute: "Azioni scadute",
    chiuse: "NC chiuse nella settimana",
    claimAperti: "Claim aperti",
    temi: "Temi ricorrenti",
    testoMail: "Testo della mail",
    nessuna: "Nessuna",
  },
};

export const en: Forma<typeof it> = {
  cruscotto: {
    titolo: "Red Flags",
    sottotitolo: "Dashboard for management and ExCo. Updated in real time, no longer on Fridays.",
    nuova: "New report",
    report: "Weekly report",
    aperti: "Open",
    urgenti: "{{n}} urgent",
    critici: "Critical",
    criticiDelta: "{{d}} since Friday",
    criticiUguali: "same as Friday",
    valore: "Value at risk",
    senzaValore: "{{n}} without value",
    persi: "Lost",
    valorePersi: "{{v}} of projects",
    costo: "Cost of poor quality",
    costoVuoto: "new field, to be filled in",
    perSeverita: "By severity (open)",
    perTipo: "By report type (open)",
    tipoProposto: "proposed type",
    tipoDaScegliere: "Type to be chosen",
    inRitardo: "Late on PRO 09",
    inRitardoNota: "customer update overdue",
    azioni: "Open actions",
    azioniScadute: "{{n}} overdue",
    proposti: "{{n}} proposed",
    temi: "Recurring themes",
    temiNota: "Themes are computed from the classified causes (field “who caused it”), never written by hand.",
    temiVuotoTitolo: "No themes",
    temiVuoto: "They appear when the admin approves type and causes with «who caused it».",
    fornitori: "Suppliers with most cases",
    fornitoriRiga: "{{nc}} NCs · {{claim}} claims",
    fornitoriRigaNc: "{{nc}} NCs",
    fornitoriVuoto: "No supplier with NCs",
    andamento: "Weekly trend",
    andamentoNota: "Open reports at the end of each week.",
    andamentoTip: "{{s}}: {{n}} open",
  },
  elenco: {
    titolo: "Reports",
    sottotitolo: "{{n}} reports. New and updated first, then by date.",
    cerca: "Search customer, project, PO…",
    tutteSeverita: "All severities",
    tuttiStati: "All statuses",
    tutteSocieta: "All companies",
    tuttiTipi: "All types",
    soloUrgenti: "Urgent only",
    soloAperte: "Open only",
    soloRitardo: "Late on PRO 09",
    soloVip: "VIP only",
    tutteFonti: "All sources",
    tuttiTipiSegnalazione: "All types",
    prossimo: "Next update",
    azioni: "Actions",
    codice: "Code",
    data: "Date",
    cliente: "Customer / project",
    societa: "Company",
    severita: "Severity",
    valore: "Value",
    tipo: "Type",
    nc: "NC",
    owner: "Owner",
    stato: "Status",
    vuoto: "No reports match these filters",
  },
  flag: { NEW: "NEW", UPD: "UPD." },
  urgente: "URG",
  vip: "VIP",
  urgenteLungo: "URGENT",
  processo: {
    p1: "1 · Reported",
    p1r: "whoever receives it",
    p2: "2 · Taken in charge",
    p2r: "right away (PRO 09)",
    p3: "3 · Actions in progress",
    p3r: "corrective and preventive",
    p4: "4 · Closed",
    p4r: "checked with the customer",
  },
  pro09: {
    titolo: "Customer timing (PRO 09)",
    ricevuta: "Received on",
    presaInCarico: "Taken in charge",
    nonPresa: "not yet",
    prendi: "Take in charge",
    presaOk: "Taken in charge",
    ultimo: "Last update to the customer",
    nessuno: "none",
    prossimo: "Next update due",
    inRitardo: "{{n}} working days late",
    inTempo: "on time",
    regola: "First update within 2 working days, then every 5 (VIP every 2), until closure.",
    regolaVip: "VIP customer: update every 2 working days.",
    registra: "Log update to the customer",
    registraTesto: "What you told the customer",
    registraData: "Date of the update",
    registrato: "Customer update logged: the count restarts",
    chiusa: "Closed on {{data}}, checked with the customer",
    nonAperta: "Report not open: no deadline to meet",
    ritardoBreve: "late",
  },
  azioni: {
    titolo: "Actions (ISO 9001)",
    spiega: "Immediate corrective: contains the problem now. Preventive: so that it does not happen again.",
    crea: "Create action",
    nuova: "New action",
    modifica: "Edit action",
    aggiorna: "Update",
    aggiornaTitolo: "Update {{codice}}",
    tipo: "Type",
    descrizione: "Description",
    funzione: "Function",
    owner: "Person",
    ownerPh: "portal user or name",
    scadenza: "Due date",
    stato: "Status",
    nota: "Update note",
    notaPh: "what was done (optional)",
    vuotaTitolo: "No actions",
    vuota: "Create the immediate corrective action and, once the cause is clear, the preventive one.",
    scaduta: "overdue",
    creataOk: "Action {{codice}} created",
    verificaSoloQualita: "Quality sets «Verified»",
    storico: "Action updates",
    mie: "My actions",
    mieSottotitolo: "Actions assigned to you, across all reports.",
    tutte: "All actions",
    soloAperte: "Open only",
    soloScadute: "Overdue only",
    segnalazione: "Report",
    vuotoElenco: "No actions match these filters",
    migrata: "from the file (management action)",
  },
  allegati: {
    titolo: "Attachments",
    carica: "Drop files here or click to choose them",
    caricaNota: "Emails .msg and .eml, PDF, photos, Office. Max {{mb}} MB per file, {{n}} files at a time.",
    caricando: "Uploading…",
    caricati: "{{n}} attachments uploaded",
    vuoto: "No attachments",
    apri: "Open",
    scarica: "Download",
    rimuovi: "Remove",
    rimuoviConferma: "Remove the attachment from the report?",
    rimuoviMail: "The email's own attachments go too.",
    rimosso: "Attachment removed",
    da: "From",
    a: "To",
    cc: "Cc",
    data: "Date",
    oggetto: "Subject",
    corpo: "Email text",
    allegatiMail: "Email attachments",
    nonEstratti: "Not extracted: {{elenco}}",
    motivo_formato: "format not allowed",
    motivo_dimensione: "too large",
    motivo_profondita: "email inside an email inside an email",
    "motivo_non leggibile": "unreadable",
    caricatoDa: "{{chi}}, {{quando}}",
    anteprimaNo: "No preview for this format: download the file.",
    troppoGrande: "{{nome}}: too large (max {{mb}} MB)",
    formato: "{{nome}}: format not allowed",
    dopoCreazione: "Attachments are uploaded as soon as the report is created.",
  },
  apriNc: {
    bottone: "Open NC from this report",
    titolo: "Open a linked NC",
    nota: "A report is not an NC: open one only if an action towards a supplier or an internal function is needed, with the 8D.",
    tipo: "NC type",
    fornitore: "Supplier",
    funzione: "Function",
    apri: "Open the NC",
    aperta: "NC opened",
  },

  scheda: {
    sottotitolo: "{{codice}} · {{societa}} · first reported {{data}}",
    aggiungiAggiornamento: "Add update",
    testoAggiornamento: "What changed",
    modificaDati: "Edit data",
    cosa: "What happened",
    problema: "Issue",
    causa: "Cause (first reading)",
    impatto: "Impact on the customer",
    azioneInCorso: "Action in progress",
    notaLingua: "Texts imported from the weekly file, in the language they were written in.",
    classificazione: "Type and causes",
    tipoSegnalazione: "Report type",
    fonte: "Source",
    fonteDettaglio: "Source detail",
    vip: "VIP customer",
    creataDa: "Created by",
    verificataConCliente: "Checked with the customer (needed to close)",
    propostaInAttesa: "proposal {{codice}} · waiting for the admin",
    propostaDa: "proposed by {{chi}}",
    approvata: "approved",
    nessunaClassificazione: "Type and causes not decided yet: propose them.",
    classificazioneNota: "Report type, what the customer sees, who caused it. Approving them opens no NC: an NC is opened by hand, if needed.",
    causaCliente: "What the customer sees",
    causaChi: "Who caused it",
    fornitore: "Supplier (VendorHub)",
    fornitoreCerca: "search in VendorHub…",
    fornitoreFile: "in the file: {{nome}}",
    approvaApri: "Approve",
    modificaApprova: "Change and approve",
    rifiuta: "Reject",
    proponi: "Propose a change",
    proponiNota: "the proposal goes to the admin",
    propostaInviata: "Proposal sent to the admin",
    approvataOk: "Type and causes approved",
    ncAperteOk: "NCs opened: {{codici}}",
    rifiutataOk: "Proposal rejected",
    tipiObbligatori: "Choose the report type",
    ncTitolo: "Linked NCs",
    ncVuotaTitolo: "No NC",
    ncVuotaCommerciale: "Commercial case: it is closed with the tender analysis.",
    ncVuotaAttesa: "A report is not an NC. Quality opens one only if needed.",
    ncCol: "NC",
    ncTipo: "Type",
    ncFornitore: "Supplier / function",
    ncFase: "8D step",
    ncOwner: "Owner",
    ncScadenza: "Deadline",
    aggiornamenti: "Updates",
    nessunAggiornamento: "No updates",
    dati: "Data",
    cliente: "Customer",
    progetto: "Project",
    societa: "Company",
    valore: "Value at risk",
    costo: "Cost of poor quality",
    casoSf: "Salesforce case",
    casoSfEsempio: "e.g. 00012345",
    poSap: "SAP CO / PO",
    ownerCommerciale: "Sales owner",
    ownerQualita: "Quality owner",
    severita: "Severity",
    urgente: "Urgent",
    stato: "Status",
    claimTitolo: "Linked claim",
    claimProposto: "Link proposed ({{codice}}), to be confirmed in Proposals.",
    claimDaVerificare: "to be checked",
    proposte: "Proposals on this report",
  },
  nuova: {
    titolo: "New report",
    sottotitolo: "Two minutes. Quality completes the rest.",
    societa: "Company",
    cliente: "Customer",
    clientePh: "customer name",
    progetto: "Project / product",
    progettoPh: "e.g. EMEA shopping bags",
    problema: "What happened",
    problemaPh: "The issue as the customer sees it",
    impatto: "Impact on the customer",
    impattoPh: "what happens to the customer: line stopped, delivery at risk, image…",
    fonte: "Source",
    fontePh: "where the report comes from",
    fonteDettaglio: "Source detail",
    fonteDettaglioPh: "who reported it, reference (optional)",
    tipoSegnalazione: "Report type",
    casoSfObbligatorio: "With Salesforce as source the case number is required",
    severita: "Severity",
    urgente: "Urgent",
    valore: "Value at risk",
    valorePh: "amount",
    valuta: "Currency",
    casoSf: "Salesforce case",
    poSap: "SAP PO / CO",
    facoltativo: "optional",
    data: "Date received",
    dataNota: "PRO 09 timing starts from here",
    allegati: "Attachments",
    invia: "Send report",
    inviata: "Report {{codice}} created",
    allegatiErrore: "Report created, but the attachments were not uploaded: try again from the report page",
    obbligatorio: "Required field",
    criteri: "Severity criteria",
  },
  report: {
    titolo: "Weekly report · {{settimana}}",
    sottotitolo: "Generated by the portal. Replaces the Friday email and the attached xlsx.",
    settimana: "Week",
    copia: "Copy text for the email",
    copiato: "Text copied to the clipboard",
    bozza: "Create Outlook draft",
    generato: "Generated on {{quando}}",
    aperti: "Open",
    nuove: "New issues",
    aggiornate: "Updated",
    avanzamento: "Progress",
    ncAperte: "Open NCs",
    ncSenzaOwner: "NCs without owner",
    azioniScadute: "Overdue actions",
    chiuse: "NCs closed this week",
    claimAperti: "Open claims",
    temi: "Recurring themes",
    testoMail: "Email text",
    nessuna: "None",
  },
};
